for category in categories
    .category-area.content-table(data-category=category.id data-label=("Move to " + category.name) data-empty-label=category.name)
.category-area.content-table(data-category=null data-label='Move to Uncategorized' data-empty-label='Uncategorized')
